module.exports = __webpack_public_path__ + "fa-brands-400.f7307680c7fe85959f3e.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/webfonts/fa-brands-400.woff2
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.woff2
// module chunks = styles